/**
 * Backend kök URL'i (sonunda /api yok). CRA: REACT_APP_BACKEND_URL
 */
export function getApiBase() {
  const raw = process.env.REACT_APP_BACKEND_URL;
  const base = typeof raw === 'string' ? raw.trim() : '';
  if (base) {
    return base;
  }

  const mode = process.env.NODE_ENV || 'development';
  const isNonProd = mode === 'development' || mode === 'test';

  if (isNonProd) {
    throw new Error(
      '[DEKOSTA] REACT_APP_BACKEND_URL tanımlı değil.\n' +
        'Yerel: `cp .env.example .env` oluşturup değişkeni ekleyin (ör. http://127.0.0.1:8000 — sonunda /api yok). ' +
        'Jest: setup’ta REACT_APP_BACKEND_URL tanımlayın.'
    );
  }

  throw new Error(
    '[DEKOSTA] Production build: REACT_APP_BACKEND_URL eksik.\n' +
      'Vercel (veya CI) → Environment Variables → REACT_APP_BACKEND_URL = https://api.dekosta.com (canlı API kökü; sonunda /api yok). ' +
      'Detay: DEPLOY_ENV_CHECKLIST.md'
  );
}
